import { requestConnectionStatusCheck } from './connectionStatusEvents';

type BackendErrorResponse = {
  error?: unknown;
  message?: unknown;
};

type AxiosLikeError = {
  isAxiosError?: boolean;
  message?: string;
  response?: {
    data?: unknown;
  };
};

const getStringField = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() !== '' ? value : null;

const isAxiosLikeError = (error: unknown): error is AxiosLikeError =>
  error !== null &&
  typeof error === 'object' &&
  (error as AxiosLikeError).isAxiosError === true;

export const getApiErrorMessage = (error: unknown): string => {
  if (isAxiosLikeError(error)) {
    requestConnectionStatusCheck();

    const responseData = error.response?.data as BackendErrorResponse | undefined;

    if (responseData !== undefined && responseData !== null && typeof responseData === 'object') {
      // REQ-043: backend failures use `error`; `message` is only a compatibility fallback.
      return (
        getStringField(responseData.error) ??
        getStringField(responseData.message) ??
        error.message ??
        'Unknown error'
      );
    }

    return error.message || 'Unknown error';
  }

  if (error instanceof Error) {
    return error.message || 'Unknown error';
  }

  return getStringField(error) ?? 'Unknown error';
};
